module.exports = __webpack_public_path__ + "static/media/horse.c6808d3d.svg";